export default __webpack_public_path__ + "static/color-alpha-palette-light-7e152f2d654b174d91b1e7957f7d188e.png";